import InstagramIconSvg from '../../../../img/logos/instagram.svg';
import { createSVGComponentFromSVG } from './create-svg-components-from-svg';

export const InstagramIcon = createSVGComponentFromSVG(
    InstagramIconSvg,
    'InstagramIcon',
);
